// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const StraightenOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M15.64 6.83l-8.8 8.81c-.54.54-.52 1.45.05 2.02l4.16 4.16c.57.57 1.48.6 2.02.06l8.8-8.81c.55-.54.52-1.45-.05-2.02L17.66 6.9c-.57-.57-1.48-.6-2.02-.06zm5.2 5.2l-8.81 8.8-4.16-4.15.98-.98 2.57 2.57.98-.98-2.57-2.57.98-.97 1.6 1.59.97-.98-1.6-1.6.99-.97 2.57 2.57.98-.98-2.57-2.57.97-.98 1.7 1.69.97-.98-1.69-1.69.98-.98 4.16 4.16zM13.54 7.17L12 5.63l-6.3 6.3 1.54 1.54-4.04-.06-.06-4.04 1.54 1.54 6.3-6.3-1.54-1.54 3.97.13.13 3.97z","fill":"currentColor"}}]},"name":"straighten","theme":"outlined"};

const StraightenOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={StraightenOutlinedSvg} />;
  StraightenOutlined.displayName = 'StraightenOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(StraightenOutlined);
